<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)
export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    chartData: {
      type: Object,
      
    },
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 950
    },
    height: {
      type: Number,
      default: 300
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartDatas: {
        labels: [
          'Octubre',
          'Noviembre',
          'Diciemnbre',
          'Enero',
          'Febrero',
          'Marzo',
          'Abril'
        ],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [35237343.34, 39, 10, 40, 39, 80, 40]
          }
        ]
      },
      chartOptions: {
        
        
        responsive: true,
        maintainAspectRatio: false,
      
        plugins: {  
          datalabels: {
            formatter: function(value) {
              let number = parseFloat(value)
                return `$${number.toLocaleString("en-US")}`
            } ,
            labels: {
              title: {
                color:'white',
                font: {
                
                  weight: "bold",
                  size: 15,
                },
              },
            },
          },
         
        },
      },
    }
  }
}
</script>
